import { useEffect, type ReactElement } from 'react';
import { useTranslation } from 'react-i18next';

import { withAuthLayout } from './authLayout.page';
import { UserTypeSelection } from './components/UserTypeSelection';

const UserTypeSelectionPageComponent = (): ReactElement => {
    const { t } = useTranslation('auth');

    useSetPostLoginRedirectToStudy();

    return (
        <div id="login_content">
            <h1 className="header" id="login_header">
                {t('login.welcome_back')}
            </h1>
            <UserTypeSelection />
        </div>
    );
};

/**
 * Depends on UserTypeSelectionPage being on /login page, which FX uses to link to LX
 *
 * Sets the post login redirect url to the specific study
 */
const useSetPostLoginRedirectToStudy = () => {
    useEffect(() => {
        const queryParams = new URLSearchParams(window.location.search);
        const studyId = queryParams.get('studyId');
        if (studyId) {
            localStorage.setItem('postLoginRedirectUrl', '/' + window.location.search);
        }
    }, []);
};

const UserTypeSelectionPage = withAuthLayout(UserTypeSelectionPageComponent);

export default UserTypeSelectionPage;
